enum NodeType {
  LEGAL_PERSON = 'LEGAL_PERSON',
  NATURAL_PERSON = 'NATURAL_PERSON',
}

export { NodeType };
